import { useDeleteApiKeyMutation } from "../../../../generated/graphql";
import { useStatusToasts } from "../../../../hooks/useStatusToasts";
import { Emphasis } from "../../../Common/__styles__/Typography";
import { useDeleteModal } from "../../../Common/DeleteModal";
import { Body } from "../../../Common/Typography";
import { AccountAPIKey } from "./__queries__/apiKeyQueries";

export const useDeleteAPIKeyModal = ({
  apiKey,
  refetch,
}: {
  apiKey: AccountAPIKey;
  refetch: () => void;
}) => {
  const { addSuccessToast, addErrorToast } = useStatusToasts();

  const [deleteAPIKey] = useDeleteApiKeyMutation({
    onCompleted: () => {
      refetch();
      addSuccessToast(`${apiKey.name} deleted successfully`);
    },
    onError: error => {
      addErrorToast(error.message);
    },
  });

  return useDeleteModal({
    headerText: "Delete API key",
    subheaderText: apiKey.name,
    Content: (
      <Body size="large" type="regular">
        Are you sure? Any integrations using this key will stop working.{" "}
        <Emphasis>This action cannot be undone.</Emphasis>
      </Body>
    ),
    deleteButtonText: "Delete API key",
    size: "small",
    onDelete: () => {
      void deleteAPIKey({ variables: { id: apiKey.id } });
    },
    dependencies: [apiKey, refetch],
  });
};
